import { copyToClipboard } from '@gonfalon/dom/copyToClipboard';
import { IconButton, Text, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import styles from './EntityKey.module.css';

export function EntityKey({ value }: { value: string }) {
  return (
    <div className={styles.key}>
      <Text className={styles.value}>{value}</Text>
      <TooltipTrigger>
        <IconButton
          onPress={async () => {
            await copyToClipboard(value, `Copied ${value}`);
          }}
          aria-label={`Copy ${value} to clipboard`}
          icon="copy-clipboard"
          size="small"
          variant="minimal"
        />
        <Tooltip placement="bottom">Copy {value} to clipboard</Tooltip>
      </TooltipTrigger>
    </div>
  );
}
